module.exports = "<app-header [showSubtitle]=\"true\" [text]=\"'Girl With Nerd'\"></app-header>\n<app-articles></app-articles>\n<app-footer></app-footer>\n"